import React from "react"

function FilterBadge({name, on_click, is_active, children}) {
  return (
    <button
      onClick={on_click}
      className={
        `badge badge--small badge-${name} ${is_active ? "active" : ""}`
      }
    >
      {children}
    </button>
  )
}

export default FilterBadge
